import { Dispatch, SetStateAction, useContext, useEffect, useState } from 'react'
import { Box, Grid, Stack } from '@mui/material'
import { SONG_TYPES, Song } from '../../../utils/types'
import BasicToggleButtonGroup from '../../../assets/components/BasicToggleButtonGroup'
import { useCurrentUser } from '../../../hooks/contexts/currentUserContext'
import { PolyglotContext } from '../../../polyglot/polyGlotContext'

interface CategorySelectorProps {
    category: string | undefined
    setCategory: Dispatch<SetStateAction<string | undefined>>
    type: SONG_TYPES
}

type Categories = {
    soundbanks: string[]
    music: string[]
    key: string[]
    scale: string[]
    keytone: string[]
    [key: string]: any
}

const getCategories = (songList: Song[]) => {
    let categories: Categories = { soundbanks: [], music: [], key: [], scale: [], keytone: [] }

    // Get all categories from song list
    songList.forEach((song) => {
        // If song category not in the list yet, add it
        if (song.type === SONG_TYPES.KEY) {
            if (song.key) {
                if (!categories[song.type].includes(song?.key?.tonic)) {
                    categories[song.type].push(song.key.tonic)
                }
            }
        } else {
            if (!categories[song.type].includes(song.translatedCategory ?? song.category)) {
                categories[song.type].push(song.translatedCategory ?? song.category)
            }
        }
    })

    return categories
}

const CategorySelector = ({ category, setCategory, type }: CategorySelectorProps) => {
    const { polyglot } = useContext(PolyglotContext)
    const [reset, setReset] = useState<boolean>(false)
    const songList = useCurrentUser()?.songList || []
    let categories = getCategories(songList)

    useEffect(() => {
        setReset((prev) => !prev)
    }, [type])

    return (
        <Stack direction={'column'} sx={{ width: '100%', gap: 1 }}>
            <Grid item xs>
                <Box>
                    {type === SONG_TYPES.MUSIC && <BasicToggleButtonGroup items={['all', ...categories.music]} defaultSelected={'all'} selected={category} setSelected={setCategory} reset={reset} />}
                    {type === SONG_TYPES.SOUNDBANKS && <BasicToggleButtonGroup items={['all', ...categories.soundbanks]} defaultSelected={'all'} selected={category} setSelected={setCategory} reset={reset} />}
                    {type === SONG_TYPES.KEY && <BasicToggleButtonGroup items={['all', ...categories.key]} defaultSelected={'all'} selected={category} setSelected={setCategory} reset={reset} />}
                </Box>
            </Grid>
        </Stack>
    )
}

export default CategorySelector
